import { createSelector } from 'reselect'
import { RootState } from 'store/rootReducer'

const exportLogSelector = (s: RootState) => s.exportLogs

export const getExportLogs = createSelector(
  exportLogSelector,
  s => s.exportLogs,
)
